// Module
var code = "<div id=\"arHeader\"></div>\r\n<div id=\"arBody\">\r\n\t<div id=\"arWrapper\">\r\n\t\t<div id=\"arSidebar\"></div>\r\n\t\t<div id=\"arMain\"></div>\r\n\t</div>\r\n</div>\r\n<div id=\"arFooter\"></div>\r\n<div id=\"arNote\"></div>";
// Exports
export default code;